module.exports = "\n\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /Users/jmiller/Projects/Real/j-trip/j-trip/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main